module.exports = __webpack_public_path__ + "img/notice-modal-fr-FR.b29030ca.png";